import { render } from "./socialVideo.vue?vue&type=template&id=b271a8ee"
import script from "./socialVideo.vue?vue&type=script&lang=js"
export * from "./socialVideo.vue?vue&type=script&lang=js"

import "./socialVideo.vue?vue&type=style&index=0&id=b271a8ee&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__